import React, { useState } from 'react'

import { Timer } from './Timer'
import { ProgressBar } from './ProgressBar'

import styled from 'styled-components'

export const BannerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: var(--border-radius-sm);
  border: 1px solid var(--color-neutral-70);
  overflow: hidden;
  margin: 0 var(--spacing-inline-xxxs) var(--spacing-inline-xxxs);
  width: auto;
  max-width: 1272px;
  @media (min-width: 1272px) {
    margin: auto;
  }
`

export const BannerTextWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #ffff;
  gap: var(--spacing-inline-quarck);
  padding: var(--spacing-inline-xxxs);
  @media (min-width: 1000px) {
    flex-direction: row;
    padding: var(--spacing-inline-xs);
  }
`

export const BannerText = styled.span`
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-bold);
  line-height: var(--font-lineheight-distant);
  color: var(--color-neutral-130);
`

export default function BannerWithTimer({ userDiscount, unsetUserDiscount }) {
   const [timeToEnd, setTimeToEnd] = useState(
    userDiscount?.expirationDate ? new Date(userDiscount.expirationDate).getTime() - Date.now() : null
  )

  if (timeToEnd === null || !userDiscount) {
    return null
  }
  if (timeToEnd <= 0) {
    unsetUserDiscount()
    return null
  }
  return (
    <BannerWrapper>
      <BannerTextWrapper>
        <BannerText>Seu desconto vai expirar em:</BannerText>
        {userDiscount.expirationDate && (
          <Timer
            dateToEnd={new Date(userDiscount.expirationDate)}
            setTimeToEnd={(timeToEnd) => setTimeToEnd(timeToEnd)}
          />
        )}
      </BannerTextWrapper>
      <ProgressBar
        progress={(timeToEnd / ((userDiscount.totalDuration ?? 3600) * 1000)) * 100}
      />
    </BannerWrapper>
  )
}